/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { whatsAppTemplateStore } from '../../axios/whatsAppTemplateStore'
import type {
	WhatsAppTemplateStoreError,
	WhatsAppTemplateStorePathParams,
	WhatsAppTemplateStoreRequest,
	WhatsAppTemplateStoreResponse,
} from '../../types/WhatsAppTemplateStore'

export const whatsAppTemplateStoreMutationKey = () =>
	[{ url: '/organisations/:organisationId/whatsapp-templates' }] as const

export type WhatsAppTemplateStoreMutationKey = ReturnType<typeof whatsAppTemplateStoreMutationKey>

export type WhatsAppTemplateStoreVariables = {
	organisationId: WhatsAppTemplateStorePathParams['organisationId']
	data: WhatsAppTemplateStoreRequest
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppTemplateController.php WhatsAppTemplateController::store */
export function useWhatsAppTemplateStore<TContext = unknown>(
	options?: UseMutationOptions<
		WhatsAppTemplateStoreResponse,
		AxiosError<WhatsAppTemplateStoreError>,
		WhatsAppTemplateStoreVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: whatsAppTemplateStoreMutationKey(),
		mutationFn: ({ organisationId, data }: WhatsAppTemplateStoreVariables) =>
			whatsAppTemplateStore(organisationId, data, config).then(res => res.data),
		...options,
	})
}
